import { useEffect, useState } from 'react';

export type SearchResult = {
  id: string;
  title: string;
  url: string;
  category: string;
};
export type SearchEventResultType = 'match' | 'topics';

export interface UseSearch {
  (query: string): { data: SearchResult[]; error?: Error; ready: boolean; query: string };
}

async function wait(delayMs: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, delayMs);
  });
}

export const createFakeSearch = (
  searchResults: SearchResult[],
  options?: { minLength?: number; delayMs?: number }
): UseSearch => {
  return function useSearch(query: string) {
    const minSearchLength = options?.minLength ?? 3;

    const [results, setResults] = useState<SearchResult[]>([]);
    const toSearch = query.trim().toLowerCase();
    const ready = query.trim().length >= minSearchLength;
    const error = searchResults ? undefined : new Error('no search items to filter');

    useEffect(() => {
      if (ready) {
        const updatedResults = searchResults?.filter((r) =>
          // article is a result if the search is included in its title
          r.title.toLowerCase().includes(toSearch)
        );
        // add some delay to the fake search
        wait(options?.delayMs ?? 0).then(() => setResults(updatedResults));
      }
    }, [ready, toSearch]);

    return { data: results, error, ready, query: toSearch };
  };
};
